import Firestore from '../initFirebase'
import { globalOnDemandVars } from '../../helper/context'
import {
  handleErrorInCatch,
  notSavedInAnonymous,
  notSavedInSharing,
  savingEnd,
  savingStart
} from '../../helper/functions'

export async function createSpreadsheet (id, input) {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }
  const collectionReference = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('Spreadsheets')

  const data = {
    id,
    // rows: input.rows,
    columns: input.columns,
    selectedItems1: input.selectedItems1,
    selectedItems2: input.selectedItems2,
    configForItems1: input.configForItems1,
    configForItems2: input.configForItems2,
    switchForMultipleCard: input.switchForMultipleCard
  }

  try {
    savingStart()
    await collectionReference.doc(id).set(data)

    if (input.rows) {
      const rowsReference = collectionReference.doc(id).collection('Rows')

      input.rows.forEach(async (row) => {
        await rowsReference.doc(row.configForRow.id).set(row)
      })
    }
    savingEnd()
  } catch (e) {
    handleErrorInCatch(e, 'createData.js')
  }

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'createSpreadsheet',
      preview: id,
      value: {
        id, input
      }
      // , important: true
    })
  }
}
